module.exports = __webpack_public_path__ + "static/img/FuQuan_pipa_summer.a67b6835.png";